export default function CarrierPanel() {

  return (
      <p>پنل شرکت حمل</p>
  );
};